import { render } from "./UserCard.vue?vue&type=template&id=b319d1fa&scoped=true"
import script from "./UserCard.vue?vue&type=script&lang=ts"
export * from "./UserCard.vue?vue&type=script&lang=ts"

import "./UserCard.vue?vue&type=style&index=0&id=b319d1fa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b319d1fa"

export default script